import { MoreVert } from '@mui/icons-material';
import { Chip, ClickAwayListener, IconButton, MenuItem, MenuList, Paper, Popper } from '@mui/material';
import { ColDef, ITooltipParams, ValueGetterParams } from 'ag-grid-community';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { AgGridReact, AgGridReactProps } from 'ag-grid-react';
import dayjs from 'dayjs';
import { useMemo, useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { GetCustomerSettingsResponse, AllocationModel } from '../../../../Generated/Commodity-Management-Api';
import { ContractDateHelper } from '../../../../Helpers';
import { StoneXGrid } from '../../../StoneX';
import { AllocationRow, AllocationReportColumn, AllocationReportRow, AllocationColumns } from './Types';
import { StoneXNumber } from '../../../StoneXMui';

interface AllocationTableProps {
    customerSettings: GetCustomerSettingsResponse;
    allocations: AllocationModel[];
    onEditAllocation: (allocationId: number) => void;
    onViewAuditTrail: (allocationId: number) => void;
}

export default function AllocationTable({  ...props }: AllocationTableProps) {
    const { customerSettings, allocations, onViewAuditTrail, onEditAllocation } = props;

    const [columns, setColumns] = useState<ColDef<AllocationReportRow>[]>();

    function updateColumns() {
        
        let columnsToShow: AllocationReportColumn[] = Object.keys(AllocationColumns) as AllocationReportColumn[];
        columnsToShow = columnsToShow.filter(col => col !== 'Portfolio' && col !== 'TradePrice' && col !== 'PositionType' && col !== 'SettlementType');
        
        const columnDefs = columnsToShow.map((column: AllocationReportColumn) => AllocationColumns[column] as ColDef<AllocationReportRow>);

        columnDefs.filter(col => col.colId === 'actions').forEach(col => {
            col.cellRenderer = (params: ICellRendererParams<AllocationRow>) => {
                const [open, setOpen] = useState(false);
                const anchorRef = useRef<HTMLButtonElement | null>(null);

                return <div>
                    <IconButton ref={anchorRef} sx={{ borderRadius: 1 }} onClick={() => setOpen(true)}><MoreVert /></IconButton>

                    <Popper open={open} anchorEl={anchorRef.current} placement="bottom-end" >
                        <ClickAwayListener onClickAway={() => setOpen(false)}>
                            <Paper>
                                <MenuList autoFocusItem={open}>
                                    <MenuItem onClick={() => { props.onEditAllocation( params.data!.allocationGroupId!); setOpen(false) }}>Edit</MenuItem>
                                </MenuList>
                            </Paper>
                        </ClickAwayListener>
                    </Popper>
                </div>
            }
        });

        setColumns(columnDefs);
    }
    const gridOptions: AgGridReactProps = useMemo(() => {
        return {
            rowGroupPanelShow: 'never',
            enableRangeSelection: true,
            groupDisplayType: "groupRows",
            defaultColDef: {
                sortable: true,
                resizable: true,
            },
            groupRowRendererParams: {
                suppressCount: true,
                comparator: (valueA: any, valueB: any) => {
                    if (valueA == null) return 1;
                    if (valueB == null) return -1;
                    return ContractDateHelper.sortAscending(valueA, valueB);
                },
                innerRenderer: (params: any) => {
                    const shortMonthYear = params.value;
                    const date = dayjs(shortMonthYear, "MMM YY");
                    return date.isValid() ? date.format("MMMM YYYY") : shortMonthYear;
                },
            },
        };
    }, []);


    useEffect(updateColumns, [])
    return (
        <StoneXGrid
            rows={allocations}
            columns={columns!}
            gridOptions={gridOptions}
            getRowId={x => x.data.allocationGroupId}
        />
    );

}